import { Box, Button, Modal, SpaceBetween, StatusIndicator, Table } from '@amzn/awsui-components-console';
import React from 'react';
import { ActivityInfoWithStatus } from '../activity/LastActivityExecution';
import { OperationStatus } from './PipelineBulkActionConfirmModal';
import { capitalize } from 'lodash-es';

// Column definitions for the bulk action modal table
const getBulkActionModalColumns = (activityStatuses: Record<number, OperationStatus>) => [
	{
		id: 'activityId',
		header: 'Activity ID',
		cell: ({ activityId }: ActivityInfoWithStatus) => activityId,
	},
	{
		id: 'activityName',
		header: 'Activity Name',
		cell: ({ activityName }: ActivityInfoWithStatus) => activityName,
	},
	{
		id: 'updateStatus',
		header: 'Update Status',
		cell: ({ activityId }: ActivityInfoWithStatus) => {
			const status = activityStatuses[activityId] || OperationStatus.PENDING;
			return <StatusIndicator type={status}>{capitalize(status)}</StatusIndicator>;
		},
	},
];

export default function PipelineBulkActionProgressModal(props: {
	pipelineName: string;
	action: string;
	setAction: (action: string) => void;
	validActivities: ActivityInfoWithStatus[];
	activityStatuses: Record<number, OperationStatus>;
}) {
	return (
		<Modal
			onDismiss={() => props.setAction('')}
			visible={props.action !== ''}
			closeAriaLabel="Close bulk action modal"
			size="large"
			footer={
				<Box float="right">
					<SpaceBetween size="xs" direction="horizontal">
						<Button iconName="close" onClick={() => props.setAction('')}>
							Dismiss
						</Button>
					</SpaceBetween>
				</Box>
			}
			header={`Bulk ${props.action} (${props.validActivities?.length})`}
		>
			<SpaceBetween size="m">
				<div>
					Performing {props.action.toLowerCase()} on the following <b>{props.validActivities?.length}</b>{' '}
					activities; closing out this window will not stop execution.
				</div>

				<Table
					items={props.validActivities}
					columnDefinitions={getBulkActionModalColumns(props.activityStatuses)}
				/>
			</SpaceBetween>
		</Modal>
	);
}
